import Login from '../components/Login.svelte'

window.thundertech.assignController('login', (element) => {
  const configurationScript = element.querySelector('[data-hook~="login.configuration"]')
  const configuration = JSON.parse(configurationScript.textContent)
  element.removeChild(configurationScript)


  const svelteApp = new Login({
    target: element,
    props: {
      configuration,
    },
  })

  const controller = {
    svelteApp,
  }

  return controller
})
